(function () {
    'use strict';

    angular
        .module('app.detailInfluencerGroup')
        .controller('detailInfluencerGroupCtrl', ['$scope', '$rootScope', '$http', '$filter', '$modal', '$state', '$stateParams', '$location', 'adminService', 'detailInfluencerGroupService', 'TRACK_EVENTS',
            function ($scope, $rootScope, $http, $filter, $modal, $state, $stateParams, $location, adminService, detailInfluencerGroupService, TRACK_EVENTS)
            {
                var me = this;
                var definitions = angular.copy($rootScope.definitions);
                $scope.listCountry = [];
                angular.forEach(definitions.countries, function(country) {
                    if(country.isActive == 1) {
                        $scope.listCountry.push(country);
                    }
                })

                $scope.flag = false;
                $scope.pageSize = 25;
                $scope.pageNo = 1;
                $scope.influencersGroup = [];
                $scope.currentData = null;
                $scope.openAdvance = false;
                $scope.selectedCountry = null;
                $scope.selectedPlatform = null;

                $scope.reachFrom = null;
                $scope.reachTo = null;
                $scope.engagementFrom = null;
                $scope.engagementTo = null;
                $scope.impactFrom = null;
                $scope.impactTo = null;

                $scope.sortOrderBy = false;
                $scope.sortString = null;
                $scope.sortIcon = null;

                var url_getPlatform = $rootScope.apiUrl + "admin/getPlatform"; 
                $http.get(url_getPlatform , {loader: false})
                    .success(function(resultPlatform){
                        $scope.listPlatform = resultPlatform.data;
                    })
                
                $scope.getInfluencerGroupInfo = function(influencer_group_id) {
                    detailInfluencerGroupService.getInfluencerGroupInfo(influencer_group_id)
                        .then(function(response) {
                            $scope.influencerGroupInfo = response.data;
                            $scope.searchInfluencersOfInfluencerGroup();
                        }, function(response) {

                        })
                }

                $scope.clickAdvance = function(){
                    if(!$scope.openAdvance) $scope.openAdvance = true;
                    else $scope.openAdvance = false;
                }

                $scope.backInfluencerGroup = function() {
                    $state.transitionTo("home.influencer", {},{
                        reload: false,
                        inherit: false,
                        notify: true
                    });
                }

                $scope.influencerOverviewPage = function(influencer_id){
                    $rootScope.previousPage = $location.absUrl();
                    $state.transitionTo('home.influencerOverview', {influencer_id: influencer_id}, {
                        reload: false,
                        inherit: true,
                        notify: true
                    });
                }

                $scope.sendHttpRequest = function ()
                {
                    declareSlider();
                    $scope.getInfluencerGroupInfo($stateParams.influencer_group_id);

                    var result = null;
                    detailInfluencerGroupService.getManualAddedInfluencerList($stateParams.influencer_group_id)
                       .then(function(result){
                           $scope.manualAddedInfluencerList = result.data;
                       })
                       .catch(function(message){
                       })
                       .finally(function(){
                       }); 
                }
                $scope.executeLoadData = function(params){
                    detailInfluencerGroupService.getInfluencerGroupInfluencerKPI(params)
                        .then(function(result){
                            $scope.influencerListOfInfluencerGroup = result.data;
                            $scope.totalRow = result.totalRow;
                        })
                        .catch(function(message){})
                        .finally(function(){});
                }

                $scope.updatePage= function(val){
                    if($scope.openAdvance){
                        $scope.listCountry.forEach(function(country){
                            if(country.ticked == true) 
                                $scope.selectedCountry = country.id;
                        })

                        $scope.listPlatform.forEach(function(platform){
                            if(platform.ticked == true)
                                $scope.selectedPlatform = platform.id;
                        })

                        $scope.reachFrom = $scope.monthlyReach ? $scope.monthlyReach[0] : $scope.monthlyReachSlider[0]["value"].split(',')[0];
                        $scope.reachTo = $scope.monthlyReach ? $scope.monthlyReach[1] : $scope.monthlyReachSlider[0]["value"].split(',')[1];
                        $scope.engagementFrom = $scope.avgEngagementsPerPost ? $scope.avgEngagementsPerPost[0] :  $scope.avgEngagementsPerPostSlider.val().split(',')[0];
                        $scope.engagementTo = $scope.avgEngagementsPerPost ? $scope.avgEngagementsPerPost[1] :  $scope.avgEngagementsPerPostSlider.val().split(',')[1];
                        $scope.impactFrom = $scope.avgImpact ? $scope.avgImpact[0] : $scope.avgImpactSlider.val().split(',')[0];
                        $scope.impactTo = $scope.avgImpact ? $scope.avgImpact[1] : $scope.avgImpactSlider.val().split(',')[1];
                
                    }else {
                        $scope.selectedCountry = null;
                        $scope.selectedPlatform = null;
                        $scope.reachFrom = null;
                        $scope.reachTo = null;
                        $scope.engagementFrom = null;
                        $scope.engagementTo = null;
                        $scope.impactFrom = null;
                        $scope.impactTo = null;
                    }

                    $scope.pageNo = val;

                    var params = {
                        influencerGroup_id: $stateParams.influencer_group_id,
                        company_id: $scope.influencerGroupInfo.company_id,
                        pageSize: $scope.pageSize,
                        pageNo :val,
                        searchString: $scope.searchString,
                        selectedCountry: $scope.selectedCountry,
                        selectedPlatform: $scope.selectedPlatform,
                        reachFrom: $scope.reachFrom,
                        reachTo: $scope.reachTo,
                        engagementFrom: $scope.engagementFrom,
                        engagementTo: $scope.engagementTo,
                        impactFrom: $scope.impactFrom,
                        impactTo: $scope.impactTo
                    };

                    $scope.executeLoadData(params);
                }

                $scope.searchInfluencersOfInfluencerGroup = function(){
                    if($scope.openAdvance){
                        $scope.listCountry.forEach(function(country){
                            if(country.ticked == true) 
                                $scope.selectedCountry = country.id;
                        })

                        $scope.listPlatform.forEach(function(platform){
                            if(platform.ticked == true)
                                $scope.selectedPlatform = platform.id;
                        })

                        $scope.reachFrom = $scope.monthlyReach ? $scope.monthlyReach[0] : $scope.monthlyReachSlider[0]["value"].split(',')[0];
                        $scope.reachTo = $scope.monthlyReach ? $scope.monthlyReach[1] : $scope.monthlyReachSlider[0]["value"].split(',')[1];
                        $scope.engagementFrom = $scope.avgEngagementsPerPost ? $scope.avgEngagementsPerPost[0] :  $scope.avgEngagementsPerPostSlider.val().split(',')[0];
                        $scope.engagementTo = $scope.avgEngagementsPerPost ? $scope.avgEngagementsPerPost[1] :  $scope.avgEngagementsPerPostSlider.val().split(',')[1];
                        $scope.impactFrom = $scope.avgImpact ? $scope.avgImpact[0] : $scope.avgImpactSlider.val().split(',')[0];
                        $scope.impactTo = $scope.avgImpact ? $scope.avgImpact[1] : $scope.avgImpactSlider.val().split(',')[1];
                
                    }else {
                        $scope.selectedCountry = null;
                        $scope.selectedPlatform = null;
                        $scope.reachFrom = null;
                        $scope.reachTo = null;
                        $scope.engagementFrom = null;
                        $scope.engagementTo = null;
                        $scope.impactFrom = null;
                        $scope.impactTo = null;
                    }

                    var pageNo = 1;

                    if ($scope.pageNo > 1){
                        pageNo = $scope.pageNo;
                    }

                    var params = {
                        influencerGroup_id: $stateParams.influencer_group_id,
                        company_id: $scope.influencerGroupInfo.company_id,
                        pageSize: $scope.pageSize,
                        pageNo :pageNo,
                        searchString: $scope.searchString,
                        selectedCountry: $scope.selectedCountry,
                        selectedPlatform: $scope.selectedPlatform,
                        reachFrom: $scope.reachFrom,
                        reachTo: $scope.reachTo,
                        engagementFrom: $scope.engagementFrom,
                        engagementTo: $scope.engagementTo,
                        impactFrom: $scope.impactFrom,
                        impactTo: $scope.impactTo
                    };

                    $scope.executeLoadData(params);
                }

                $scope.sortInfluencersOfInfluencerGroup = function(sortString) {
                    if($scope.openAdvance){
                        $scope.listCountry.forEach(function(country){
                            if(country.ticked == true) 
                                $scope.selectedCountry = country.id;
                        })

                        $scope.listPlatform.forEach(function(platform){
                            if(platform.ticked == true)
                                $scope.selectedPlatform = platform.id;
                        })

                        $scope.reachFrom = $scope.monthlyReach ? $scope.monthlyReach[0] : $scope.monthlyReachSlider[0]["value"].split(',')[0];
                        $scope.reachTo = $scope.monthlyReach ? $scope.monthlyReach[1] : $scope.monthlyReachSlider[0]["value"].split(',')[1];
                        $scope.engagementFrom = $scope.avgEngagementsPerPost ? $scope.avgEngagementsPerPost[0] :  $scope.avgEngagementsPerPostSlider.val().split(',')[0];
                        $scope.engagementTo = $scope.avgEngagementsPerPost ? $scope.avgEngagementsPerPost[1] :  $scope.avgEngagementsPerPostSlider.val().split(',')[1];
                        $scope.impactFrom = $scope.avgImpact ? $scope.avgImpact[0] : $scope.avgImpactSlider.val().split(',')[0];
                        $scope.impactTo = $scope.avgImpact ? $scope.avgImpact[1] : $scope.avgImpactSlider.val().split(',')[1];
                
                    } else {
                        $scope.selectedCountry = null;
                        $scope.selectedPlatform = null;
                        $scope.reachFrom = null;
                        $scope.reachTo = null;
                        $scope.engagementFrom = null;
                        $scope.engagementTo = null;
                        $scope.impactFrom = null;
                        $scope.impactTo = null;
                    }

                    $scope.sortString = sortString;
                    $scope.sortOrderBy = !$scope.sortOrderBy;
                    if($scope.sortOrderBy) {
                        $scope.iconName = "glyphicon glyphicon-chevron-down";
                    } else {
                        $scope.iconName = "glyphicon glyphicon-chevron-up";
                    }

                    var params = {
                        influencerGroup_id: $stateParams.influencer_group_id,
                        company_id: $scope.influencerGroupInfo.company_id,
                        pageSize: $scope.pageSize,
                        pageNo : $scope.pageNo,
                        searchString: $scope.searchString,
                        selectedCountry: $scope.selectedCountry,
                        selectedPlatform: $scope.selectedPlatform,
                        reachFrom: $scope.reachFrom,
                        reachTo: $scope.reachTo,
                        engagementFrom: $scope.engagementFrom,
                        engagementTo: $scope.engagementTo,
                        impactFrom: $scope.impactFrom,
                        impactTo: $scope.impactTo,
                        sortString: $scope.sortString,
                        orderBy: $scope.sortOrderBy
                    };

                    $scope.executeLoadData(params);
                }

                $scope.resetSearchInfluencers = function(){
                    $scope.searchString =null;
                    $scope.selectedCountry = null;
                    $scope.selectedPlatform = null;
                    $scope.reachFrom = null;
                    $scope.reachTo = null;
                    $scope.engagementFrom = null;
                    $scope.engagementTo = null;
                    $scope.impactFrom = null;
                    $scope.impactTo = null;

                    $scope.listCountry.forEach(function(val){
                        val.ticked = false;
                    })
                    $scope.listPlatform.forEach(function(val){
                        val.ticked = false;
                    })
                    
                    $scope.monthlyReachSlider.bootstrapSlider('setAttribute', 'value', 0);
                    $scope.monthlyReachSlider.bootstrapSlider('refresh');
                    $scope.avgEngagementsPerPostSlider.bootstrapSlider('setAttribute', 'value', 0);
                    $scope.avgEngagementsPerPostSlider.bootstrapSlider("refresh");
                    $scope.avgImpactSlider.bootstrapSlider('setAttribute','value',0);
                    $scope.avgImpactSlider.bootstrapSlider('refresh');
                }

                $scope.deleteInfluencerManualAdded = function(influencer_group_id, influencer_name, company_id, influencer_id){
                    var deleteInfluencerFromInfluencerGroupConfirmModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/influencerGroup/detailInfluencerGroup/detailInfluencerGroupPopup/detailInfluencerGroupConfirmDeleteInfluencer.html?app_v=deployDate',
                        controller: 'DeleteInfluencerFromInfluencerGroupCtrl'
                    });

                    $scope.influencer_name = influencer_name;
                    $scope.params = {
                        influencerGroup_id: influencer_group_id,
                        company_id: company_id,
                        influencer_id: influencer_id
                    };
                    $scope.deleteInfluencerFromInfluencerGroupConfirmModalInstance = deleteInfluencerFromInfluencerGroupConfirmModalInstance;
                }
            

                $scope.pagination = function()
                {
                    $scope.pages = adminService.pagination($scope.totalRow, $scope.pageSize);
                }


                function declareSlider () {
                    $scope.monthlyReachSlider = $("#monthlyReachSlider").bootstrapSlider({
                        range: true,
                        min: 0,
                        max: 1000000,
                        // values: [0,1000000],
                        tooltip: 'always',
                        tooltip_split: true,
                        formatter: function (n) {
                            if(n == 1000000) {
                                return $filter('number')(n, 0) + '+';
                            } else {
                                return $filter('number')(n, 0)
                            }
                        }
                    });
                   
                    $scope.avgEngagementsPerPostSlider = $("#monthlyEngagementsPerPostSlider").bootstrapSlider({
                        range: true,
                        min: 0,
                        max: 1000000,
                        // value: [0, $scope.sliderData.maxEngagement],
                        tooltip: 'always',
                        tooltip_split: true,
                        formatter: function (n) {
                            if(n == 1000000) {
                                return $filter('number')(n, 0) + '+';
                            } else {
                                return $filter('number')(n, 0)
                            }
                        }
                    });               
                    $scope.avgImpactSlider = $("#monthlyImpactSlider").bootstrapSlider({
                        range: true,
                        min: 0,
                        max: 300,
                        // value: [0, 400],
                        tooltip: 'always',
                        tooltip_split: true,
                        formatter: function (n) {
                            if(n == 300) {
                                return $filter('number')(n, 0) + '%+';
                            } else {
                                return $filter('number')(n, 0) + '%';
                            }
                        }
                    });

                    $scope.monthlyReachSlider.bootstrapSlider().on('slideStop', function (e) {
                        var val = $scope.monthlyReachSlider.val().split(',');
                        $scope.monthlyReach = [];
                        $scope.monthlyReach.push(val[0]);
                        $scope.monthlyReach.push(val[1]);
                        $scope.$apply();
                    })

                    $scope.avgEngagementsPerPostSlider.bootstrapSlider().on('slideStop', function (e) {
                        var val = $scope.avgEngagementsPerPostSlider.val().split(',');
                        $scope.avgEngagementsPerPost = [];
                        $scope.avgEngagementsPerPost.push(val[0]);
                        $scope.avgEngagementsPerPost.push(val[1]);
                        $scope.$apply();
                    })

                    $scope.avgImpactSlider.bootstrapSlider().on('slideStop', function (e) {
                        var val = $scope.avgImpactSlider.val().split(',');
                        $scope.avgImpact = [];
                        $scope.avgImpact.push(val[0]);
                        $scope.avgImpact.push(val[1]);
                        $scope.$apply();
                    })
                }

                $scope.openModalAddInfluencerToInfluencerGroup = function(){
                    var addInfluencerModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/influencerGroup/detailInfluencerGroup/addInfluencerToInfluencerGroup/addInfluencerToInfluencerGroup.html?app_v=deployDate',
                        controller: 'addInfluencerToInfluencerGroupCtrl'
                    });
                    
                    $scope.addInfluencerModalInstance = addInfluencerModalInstance;
                    $scope.influencer_group_id = $stateParams.influencer_group_id;
                    $scope.company_id = $scope.influencerGroupInfo.company_id;
                    $scope.manualAddedInfluencerList;

                    addInfluencerModalInstance.result.then(function (result) {
                        if(result != null && result.reload) {
                            $scope.searchInfluencersOfInfluencerGroup();
                        }
                    }, function () {
                        
                    });
                }

                if(!$scope.flag)
                {
                    $scope.sendHttpRequest();
                    $scope.flag = true;
                }

                var openDemoGraphicModal = function (influencer) {
                    // Mixpanel tracking influencer group item click
                    analytics.track(
                        TRACK_EVENTS.USE_DEMOGRAPHIC.EVT_NAME,
                        {
                            "item": TRACK_EVENTS.USE_DEMOGRAPHIC.ITEM_NAME,
                            "target_type": "Influencer",
                            "target_name": influencer.influencer_name,
                            "target_id": influencer.influencer_id
                        }
                    );

                    var modalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/influencerGroup/detailInfluencerGroup/demoGraphicModal.html?app_v=deployDate',
                        controller: 'DemoGraphicModalCtrl as vm',
                        windowClass: 'demo-graphics-modal',
                        resolve: {
                            influencer: function () {
                                return { 
                                        influencerName: influencer.influencer_name,
                                        influencerId: influencer.influencer_id
                                }
                            }
                        }                        
                    });

                    $scope.modalInstance = modalInstance;
                    modalInstance.result.then(function () {
                        
                    }, function () {
                      
                    });
                };

                me.openDemoGraphicModal = openDemoGraphicModal;


            }
        ])

.controller('DeleteInfluencerFromInfluencerGroupCtrl', ['$scope', '$rootScope', '$modal', 'detailInfluencerGroupService', '$modalInstance',
        function ($scope,$rootScope, $modal, detailInfluencerGroupService, $modalInstance) {
            $scope.confirmDeleteInfluencerFromInfluencerGroup = function () {

                detailInfluencerGroupService.deleteInfluencerManualAdded($scope.params)
                    .then(function(result){
                        $scope.closeModal();
                        $scope.searchInfluencersOfInfluencerGroup();

                        if ($scope.manualAddedInfluencerList){
                            for (var i = 0; i < $scope.manualAddedInfluencerList.length; i++){
                                if ($scope.manualAddedInfluencerList[i].influencer_id == $scope.params.influencer_id
                                && $scope.manualAddedInfluencerList[i].influencer_group_id == $scope.params.influencerGroup_id){
                                    $scope.manualAddedInfluencerList.splice(i, 1);
                                }
                            }
                        }

                    }, function(response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    })
            }

            $scope.closeModal = function () {
                $modalInstance.close();
            }
        }
    ])
})();
